<div class="container content-profile bg-white" [formGroup]="userForm">
  <div class="row p-3 form-group">
    <div class="col-3">
      <img [src]="userForm.value.image" class="user-image rounded-circle img-fluid user-profile-image-height" alt="" />
    </div>
    <div class="col-9">
      <h5 class="text-truncate pl-2">{{userForm.value.firstname}}</h5>
      <h6 class="text-truncate pl-2">{{userForm.value.mobile}}</h6>
      <span>
        <ng-select class="text-capitalize no-border-ng-select" [items]=userAddresses bindLabel="ooca_address"
          bindValue="ooca_guid" placeholder="select address" formControlName="address" type="address"
          componentFrom="search" [clearable]="false" [searchable]="false" (change)="onAddressChange($event)">
          <ng-template ng-label-tmp let-item="item">
            <span class="text-dark">{{item.ooca_address_label}}</span>
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
            <div *ngIf="index === 0" (click)="onAddAddressClick(item)">
              <button class="btn btn-secondary btn-block">Add new address</button>
            </div>
            <div (click)="onAddAddressClick(item)" *ngIf="index !== 0">
              <div>
                <span class="text-dark">{{item.ooca_address_label}}</span>
              </div>
              <small class="text-muted address-text addresstext-dropdown"
                title="{{item.ooca_address}}">{{item.ooca_address}}</small>
            </div>
          </ng-template>
        </ng-select>
      </span>
    </div>
  </div>
  <div class="row form-group text-center">
    <div class="col">
      <label class="cursor" (click)="onViewAccountClick()">
        <i class="fas fa-pencil-alt mx-1"></i>
        <span class="text-primary">Edit/View Your Account</span>
      </label>
    </div>
    <div class="col">
      <label class="cursor" (click)="onProfileDetailClick('CHANGE_PASSWORD')">
        <i class="fas fa-key mx-1"></i>
        <span class="text-primary cursor">Change Password</span>
      </label>
    </div>
  </div>
  <div class="row form-group text-center">
    <div class="col cursor h-100 d-inline-block" (click)="onProfileDetailClick('REFERRALS')">
      <div>
        <!-- <i class="fas fa-handshake fa-2x text-secondary">
        </i> -->
        <img src="./assets/images/profileicons/3.png" alt="Referrals" class="img-fluid ml-3"
          style="display: block; width: 60%;">
        <span
          class="badge rounded-pill bg-dark text-white align-top ml-1 count-position">{{userForm.controls.referralsCount.value}}</span>
      </div>
      <span for="" class="text-dark">Your Referrals</span>
    </div>
    <div class="col cursor" (click)="onProfileDetailClick('OLARS')">
      <div>
        <!-- <i class="far fa-credit-card fa-2x text-secondary"></i> -->
        <img src="./assets/images/profileicons/6.png" alt="Referrals" class="img-fluid ml-3"
          style="display: block; width: 60%;">
        <span
          class="badge rounded-pill bg-dark text-white align-top ml-1 count-position">{{userForm.controls.olarsCount.value}}</span>
      </div>
      <span for="" class="text-dark mr-5">Your Olars</span>
    </div>
  </div>
  <div class="row form-group text-center my-5">
    <div class="col cursor" (click)="onProfileDetailClick('VOUCHERS')">
      <div class="mb-3">
        <!-- <i class="fas fa-money-bill fa-2x text-secondary"></i> -->
        <img src="./assets/images/profileicons/1.png" alt="Referrals" class="img-fluid ml-3"
          style="display: block; width: 60%;">
        <span
          class="badge rounded-pill bg-dark text-white align-top ml-1 count-position">{{userForm.controls.vouchersCount.value}}</span>
      </div>
      <span for="" class="text-dark pt-5">Your Vouchers</span>
    </div>
    <div class="col cursor" (click)="onProfileDetailClick('ORDERS')">
      <div>
        <!-- <i class="fas fa-business-time fa-2x text-secondary"></i> -->
        <img src="./assets/images/profileicons/4.png" alt="Referrals" class="img-fluid ml-3"
          style="display: block; width: 60%;">
        <span class="badge rounded-pill bg-dark text-white align-top ml-1 count-position"
          style="right: 55% !important;">{{currentOrderCount}}</span>
        <span class="badge rounded-pill align-top count-position" style="right: 49% !important;">
          <i class="fas fa-plus fa-sm"></i>
        </span>
        <span class="badge rounded-pill bg-dark text-white align-top count-position">{{pastOrderCount}}</span>
      </div>
      <span for="" class="text-dark ">Your Current & Past Orders</span>
    </div>
  </div>
  <div class="row form-group text-center">
    <div class="col cursor" (click)="onProfileDetailClick('UPCOMING_RESERVATIONS')">
      <div>
        <!-- <i class="fas fa-business-time fa-2x text-secondary"></i> -->
        <img src="./assets/images/profileicons/5.png" alt="Referrals" class="img-fluid ml-3"
          style="display: block; width: 60%;">
        <span
          class="badge rounded-pill bg-dark text-white align-top ml-1 count-position">{{upcomingReservationCount}}</span>
      </div>
      <span for="" class="text-dark ">Upcoming Reservations</span>
    </div>
    <div class="col cursor" (click)="onProfileDetailClick('CONTACT_SUPPORT')">
      <div>
        <!-- <i class="fas fa-phone-volume fa-2x px-3 text-secondary"></i> -->
        <img src="./assets/images/profileicons/2.png" alt="Referrals" class="img-fluid ml-3"
          style="display: block; width: 60%;">
      </div>
      <span for="" class="text-dark ">Customer Support</span>
    </div>
  </div>
  <!-- <div class="row text-center">
    <div class="col">
      <button class="btn btn-primary btn-small box-shadow-none" (click)="onBackClick()">Back</button>
    </div>
  </div> -->
  <div class="row form-group">
    <div class="col">
      <br /><br />
    </div>
  </div>
  <!-- <div class="row form-group">
    <div class="col cursor" (click)="onProfileDetailClick('VOUCHERS')">
      <div>
        <i class="fas fa-money-bill fa-lg px-3 font-color-dark-blue"></i>
        <span for="" class="text-dark ">Vouchers</span>
      </div>
    </div>
  </div>
  <div class="row form-group">
    <div class="col cursor" (click)="onProfileDetailClick('REFERRALS')">
      <div>
        <i class="fas fa-handshake fa-lg px-3 font-color-dark-blue"></i>
        <span for="" class="text-dark ">View Referrals</span>
      </div>
    </div>
  </div>
  <div class="row form-group">
    <div class="col cursor" (click)="onProfileDetailClick('UPCOMING_ORDERS')">
      <div>
        <i class="fas fa-business-time fa-lg px-3 font-color-dark-blue"></i>
        <span for="" class="text-dark ">View upcoming reservations</span>
      </div>
    </div>
  </div>
  <div class="row form-group">
    <div class="col cursor" (click)="onProfileDetailClick('CONTACT_SUPPORT')">
      <i class="fas fa-phone-volume fa-lg px-3 font-color-dark-blue" style="width: 50px"></i><span for=""
        class="text-dark ">Contact support</span>
    </div>
  </div>
  <div class="row form-group">
    <div class="col cursor" (click)="onProfileDetailClick('LANGUAGE')">
      <i class="fas fa-globe px-3 fa-lg font-color-dark-blue" style="width: 50px"></i><span for=""
        class="text-dark">English</span>
    </div>
  </div>
  <div class="row form-group background-grey">
    <div class="col">
      <br />
    </div>
  </div>
  <div class="row form-group">
    <div class="col cursor" (click)="onProfileDetailClick('CHANGE_PASSWORD')">
      <i class="fas fa-key px-3 fa-lg font-color-dark-blue"></i><span for="" class="text-dark">Change Password</span>
    </div>
  </div>
  <div class="row form-group">
    <div class="col cursor" (click)="onProfileDetailClick('LOG_OUT')">
      <i class="fas fa-sign-out-alt px-3 fa-lg font-color-dark-blue"></i><span for="" class="text-dark">Log out</span>
    </div>
  </div> -->

</div>
<app-ecom-footer class="footer"></app-ecom-footer>
<ng-template #useraddressPopup>
  <div class="modal-header">
    <label for="" class="font-weight-bold-500">Save My Delivery Address</label>
    <i class="fas fa-times fa-lg cursor close" (click)="onCloseClick()"></i>
  </div>
  <div class="modal-body" [formGroup]="addressForm">
    <div class="row form-group">
      <div class="col">
        <input type="text" class="form-control" placeholder="Label your address" formControlName="ooca_address_label"
          [ngClass]="{'has-error': ((addressForm.get('ooca_address_label').touched || addressForm.get('ooca_address_label').dirty) &&  addressForm.get('ooca_address_label').errors)}" />
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <!-- <input aria-label="Search your location" aria-describedby="button-addon2" autocapitalize="off" spellcheck="off"
          formControlName="ooca_address"
          class="form-control font-size-14 font-weight-bold-500 box-shadow-none pac-target-input"
          ngx-google-places-autocomplete [options]='options' #placesRef="ngx-places"
          (onAddressChange)="handleAddressChange($event)"
          [ngClass]="{'has-error': ((addressForm.get('ooca_address').touched || addressForm.get('ooca_address').dirty) &&  addressForm.get('ooca_address').errors)}" /> -->
        <ng-select [searchFn]="customSearchFn" formControlName="ooca_place_id" (keyup)="placesKeyUp($event)" [items]="googlePlacesResults"
          bindLabel="description" [clearable]="true" bindValue="place_id" placeholder="Search your location"
          [searchable]="true" type="text" componentFrom="search" (change)="onLocationChange($event)"
          [ngClass]="{'address-empty': ((addressForm.get('ooca_place_id').touched || addressForm.get('ooca_place_id').dirty) &&  addressForm.get('ooca_place_id').errors)}">
        </ng-select>
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <textarea class="form-control" name="" id="" maxlength="25" rows="1" formControlName="ooca_address_landmark"
          placeholder="House / Apartment / Hotel / Other details"
          [ngClass]="{'has-error': ((addressForm.get('ooca_address_landmark').touched || addressForm.get('ooca_address_landmark').dirty) &&  addressForm.get('ooca_address_landmark').errors)}"></textarea>
      </div>
    </div>
    <div class="row form-group">
      <div class="col">
        <input type="text" class="form-control" placeholder="City" formControlName="ooca_city"
          [ngClass]="{'has-error': ((addressForm.get('ooca_city').touched || addressForm.get('ooca_city').dirty) &&  addressForm.get('ooca_city').errors)}" />
      </div>
      <div class="col">
        <input type="text" class="form-control" placeholder="Postcode" formControlName="ooca_postal_code" />
      </div>
    </div>
    <div class="row form-group align-items-center no-gutters">
      <div class="col">
        <span class="round">
          <input name="default" type="checkbox" id="default" formControlName="ooca_is_default" />
          <label class="cursor" for="default"></label>
        </span>
        <label for="default" class="text-dark cursor pt-2 pl-3">Set as default</label>
      </div>
      <div class="col text-right">
        <button class="btn btn-outline-secondary bg-dark text-white outline-0 box-shadow-none btn-block"
          (click)="onSaveAddressClick()" [disabled]="saveclicked === true">Save</button>
      </div>
    </div>
  </div>
</ng-template>
<div id="map" class="map"></div>
<div class="overlay" *ngIf="overlayDisplay">
  <app-ecom-contact-us (submitted)="contactUsEventEmitter($event)"></app-ecom-contact-us>
</div>